import {IApplicationState} from '../../../../types/types';

export const getLimitCardsNumber = (
    state: IApplicationState,
    listId: number
): number => {
    return state.model.lists[listId] && state.model.lists[listId].maxCardNumber;
};
